<div class="login-container">
  <!-- Left Panel (Illustration & Branding for Desktop/Tablets) -->
  <div class="left-panel">
    <div class="top-logos">
      <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
      <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
      <img class="asha-saathi-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
      <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
      <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
    </div>

    <div class="left-panel-text">
      {{ langService.currentLang === 'mr'
      ? 'मान्यताप्राप्त सामाजिक आरोग्य कार्यकर्त्या'
      : 'Accredited Social Health Activists' }}
    </div>

    <div class="left-panel-image-wrap">
      <img src="assets/dashboard icons/AshaPic.png" alt="Asha" class="left-hero-img" />
    </div>
  </div>

  <!-- Right Panel (Forgot Password Form) -->
  <div class="right-container">
    <div class="login-card-wrapper">
      <!-- Mobile logos strip shown when left panel is hidden -->
      <div class="mobile-logos-bar">
        <img src="assets/dashboard icons/logo1.png" alt="Logo 1">
        <img src="assets/dashboard icons/logo2.png" alt="Logo 2">
        <img class="mobile-center-logo" src="assets/dashboard icons/ashasathilogo.png" alt="Asha Saathi">
        <img src="assets/dashboard icons/logo4.png" alt="Logo 4">
        <img src="assets/dashboard icons/logo5.png" alt="Logo 5">
      </div>

      <div class="login-card">
        <div class="login-header-icon-wrap">
          <img class="login-header-icon" src="assets/icons/headericon_pink.png" alt="Asha" />
        </div>

        <h2 class="login-title">{{ titleText }}</h2>

        <p class="login-subtitle">{{ subtitleText }}</p>

        <form class="login-form">
          <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top" class="custom-login-form"
            [showColonAfterLabel]="false">

            <dxi-form-item dataField="email" editorType="dxTextBox" [editorOptions]="{
                stylingMode: 'outlined',
                placeholder: langService.currentLang === 'mr'
                  ? 'तुमचा ईमेल आयडी टाका'
                  : 'Enter your Email Id',
                buttons: [{
                  name: 'userIcon',
                  id: 'email',
                  value: formData.email,
                  location: 'after',
                  options: { icon: 'custom-user-icon' }
                }]
              }">
              <dxo-label [text]="langService.currentLang === 'mr' ? 'ईमेल आयडी' : 'Email ID'"></dxo-label>
            </dxi-form-item>
          </dx-form>

          <div class="login-action-wrap">
            <dx-button [text]="langService.currentLang === 'mr' ? 'ओटीपी पाठवा' : 'Send OTP'" type="default"
              stylingMode="contained" class="login-button" (click)="ForgetPassword()"></dx-button>
          </div>

          <div class="forgot-password-text">
            <a (click)="NavigateToLogin()">
              {{ langService.currentLang === 'mr' ? '← लॉगिनकडे परत जा' : '< Back to login' }}
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>